<template>
    <div class="layout-reminder-popup layout-reminder-version">
        <van-popup class="layout-reminder-version-pop" v-bind:value="showVersionPop && (!versionExtTime[curVersion] || (versionExtTime[curVersion] && versionExtTime[curVersion] < 0))" v-bind:close-on-click-overlay="false" >
            <div class="layout-reminder-version-close" @click="clickClose">
                <span><i class="iconfont icon-guanbi"></i></span>
            </div>
            <div class="layout-reminder-version-bg"></div>
            <div class="layout-reminder-version-title">新功能上线啦!</div>
            <div class="layout-reminder-version-sub-title">
                <span>为你变得更好</span>
            </div>
            <div class="layout-reminder-version-list">
                <p class="layout-reminder-version-item">1、新功能上线，啦新功能上，线啦新功能上线啦新功能；</p>
                <p class="layout-reminder-version-item">2、新功能上线，啦新功能上，线啦新功能上线啦新功能；</p>
                <p class="layout-reminder-version-item">3、新功能上线，啦新功能上，线啦新功能上线啦新功能；</p>
            </div>
        </van-popup>

    </div>
</template>

<script>
export default {
    name: 'ReminderShare',
    computed: {
        versionExtTime() {
            return this.$store.state.reminder.versionExtTime
        },
        versionKeyArr() {
            return this.$store.state.reminder.versionKeyArr
        }
    },
    data() {
        return {
            showVersionPop: false,
            versionIndex: 0,
            curVersion: ''
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 20);
        setTimeout(() => {
            me.checkVersion();
        }, 3000);
    },
    methods: {
        initDom() {
            this.$el.style.width = innerWidth + 'px';
            this.$el.style.height = innerHeight + 'px';
        },
        checkVersion() {
            var me = this;
            this.showVersionPop = true;
            this.$store.state.reminder.showDownloadReminder = false;

            this.curVersion = this.versionKeyArr[this.versionIndex];
            if(!this.versionExtTime[this.curVersion] || this.versionExtTime[this.curVersion] == -1) {
                this.$set(this.$store.state.reminder.versionExtTime, this.curVersion, -1);
            }else {
                if(this.versionIndex < this.versionKeyArr.length - 1) {
                    this.versionIndex++;
                    this.checkVersion();
                }else {
                    this.$store.state.reminder.showVersionReminder = false;
                    this.$store.state.reminder.showDownloadReminder = true;
                }
            }
        },
        clickClose() {
            this.showVersionPop = false;
            this.$store.state.reminder.showVersionReminder = false;
            this.$store.state.reminder.showDownloadReminder = true;
        }
    }
}
</script>
